export default "__VITE_ASSET__BgfgdmnO__"